<template>
  <div v-if="visible" class="overlay text-start">
    <div class="modal-box rounded px-5 py-4">
      <h3>{{ title }}</h3>
      <div
        class="counter"
        :class="{ celebrate: this.isCelebrateAnim }"
        ref="counter"
      >
        {{ tweened.score.toFixed(0) }}
      </div>
      <p class="text-muted">{{ details }}</p>
      <input
        type="text"
        v-model="userInput"
        :placeholder="placeholder"
        class="form-control form-control-lg my-3"
      />
      <div class="actions mt-4">
        <button @click="cancel" class="btn btn-link">Cancel</button>
        <button @click="confirm" class="btn btn-lg btn-primary w-100 ms-3">
          OK
        </button>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { gsap } from "gsap";

import confetti from "canvas-confetti";

export default {
  props: {
    title: {
      type: String,
      default: "Enter your input",
    },
    details: {
      type: String,
      default: "Please provide the required information.",
    },
    placeholder: {
      type: String,
      default: "Type here...",
    },
    score: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
      userInput: "",
      resolve: null,
      timeline: null,
      isCelebrateAnim: false,
      tweened: { score: 0 },
    };
  },
  created() {
  },
  watch: {
    score(n) {
      if (n > 0 && this.visible) {
        this.animateCount();
      }
    },
  },
  methods: {
    show() {
      this.visible = true;
      this.$nextTick(() => {
        this.animateCount();
      });
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    hide() {
      this.visible = false;
      this.tweened.score = 0; // Reset score for next use
      this.userInput = "";
    },
    confirm() {
      this.resolve(this.userInput);
      this.hide();
    },
    cancel() {
      this.resolve(null);
      this.hide();
    },

    animateCount() {
      const onComplete = this.celebrate.bind(this);

      gsap.to(this.tweened, {
        duration: 1.2,
        score: Number(this.score) || 0,
        onComplete,
      });
    },
    celebrate() {
      const colors = ["#fbda61", "#ff5acd"];
      this.isCelebrateAnim = true;
      confetti({
        particleCount: 150,
        spread: 100,
        origin: { y: 0.6 },
        colors,
        disableForReducedMotion: true,
      });
    },

    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
  },
};
</script>
  
  <style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-box {
  background-color: white;
  width: 350px;
  z-index: 1001;
}

.actions {
  display: flex;
  justify-content: space-around;
}

.counter {
  position: relative;
  font-size: max(2rem, 1rem + 12vw);
  text-align: center;
  font-variation-settings: "wght" var(--font-variation-weight, 600);
}
.celebrate {
  color: transparent;
  background-clip: text;
  background-color: #4158d0;
  background-image: linear-gradient(45deg, #ff5acd, #fbda61, #ff5acd);
  background-size: 200% auto;
  filter: drop-shadow(white 1px 1px 0) drop-shadow(#fbda61 2px 2px 2px);
  animation: bg 4s cubic-bezier(0.25, 1, 0.5, 1) forwards;
}

@keyframes bg {
  100% {
    background-position: 200% center;
  }
}
</style>
  